import { Redirect, Route } from 'react-router-dom'
import { Container } from './styles'
import React, { useCallback } from 'react';
import { useSession } from 'hooks';


const RouteCreators = ({ exact, path, component: Component, ...rest }) => {
  
  const { isLoggedIn } = useSession();
  
  const Wrapper = useCallback(() => {
    return (
      <Container>
        <Component />
      </Container>
    )
  }, [])
  
  if (!isLoggedIn) return <Redirect to='/' />

  return <Route exact={exact} path={path} component={Wrapper} {...rest} />
}

export default React.memo(RouteCreators)